'use strict';

var assign = require('lodash.assign');
var shallowCopy = require('shallow-copy');
var addCommas = require('add-commas');

function areJobsTiered(jobs) {
  return jobs.filter(function (job) {
    return typeof job.locationMatch !== 'undefined';
  }).length > 0;
}

function isPremiumJob(job) {
  return job.isPremium;
}

function isTier1Job(job) {
  return job.locationMatch === 'Exact';
}

function isTier2Job(job) {
  return job.locationMatch === 'Nearby';
}

function isTier3Job(job) {
  return job.locationMatch === 'Area';
}

function getHeader(isZeroResults, tiersExist, tier1Jobs, tier2Jobs, location, suggestionsExist) {
  if (tiersExist) {
    if (tier1Jobs.length > 0) {
      if (suggestionsExist) {
        return {
          parts: [{
            text: 'Showing jobs in '
          }, {
            highlighted: true,
            text: location.description
          }]
        };
      }

      return null;
    }

    if (tier2Jobs.length === 0) {
      return {
        parts: [{
          text: 'No results in '
        }, {
          highlighted: true,
          text: location.description
        }, {
          text: ' or in '
        }, {
          highlighted: true,
          text: location.suburbType === 'metro' ? 'surrounding suburbs' : 'surrounding localities'
        }]
      };
    }

    return {
      parts: [{
        text: 'No results in '
      }, {
        highlighted: true,
        text: location.description
      }]
    };
  }

  if (!isZeroResults && suggestionsExist) {
    return {
      parts: [{
        text: 'Showing jobs in '
      }, {
        highlighted: true,
        text: location.description
      }]
    };
  }

  return null;
}

function getTiers(results, tier1Jobs, tier2Jobs, tier3Jobs, location) {
  var tiers = [{
    jobs: tier1Jobs
  }, {
    jobs: tier2Jobs
  }, {
    jobs: tier3Jobs
  }];

  if (tiers[1].jobs.length > 0) {
    tiers[1].header = {
      isDivider: tier1Jobs.length > 0,
      parts: [{
        text: 'Showing jobs in '
      }, {
        highlighted: true,
        text: location.suburbType === 'metro' ? 'surrounding suburbs' : 'surrounding localities'
      }]
    };
  }

  if (tiers[2].jobs.length > 0) {
    tiers[2].header = {
      isDivider: tier1Jobs.length > 0 || tier2Jobs.length > 0,
      parts: [{
        text: isPremiumJob(results[0]) || isTier3Job(results[0]) ? 'Showing jobs in ' : 'We also found the following jobs in '
      }, {
        highlighted: true,
        text: location.suburbParentDescription
      }]
    };
  }

  // Prepend premium jobs to first existing tier
  var premiumJobs = results.filter(isPremiumJob);

  if (tiers[0].jobs.length === 0) {
    if (tiers[1].jobs.length === 0) {
      tiers[2].jobs = premiumJobs.concat(tiers[2].jobs);
    } else {
      tiers[1].jobs = premiumJobs.concat(tiers[1].jobs);
    }
  } else {
    tiers[0].jobs = premiumJobs.concat(tiers[0].jobs);
  }

  return tiers;
}

function addQueryStringToResults(searchQuery, results, location, inputPage) {
  if (!Array.isArray(results)) {
    return results;
  }

  var page = inputPage ? parseInt(inputPage, 10) : 1;

  var initialState = {
    results: [],
    premiumCounter: 1,
    standardCounter: 1 + (page - 1) * 20
  };

  var locationMatchToAnalyticsTier = {
    'Exact': 'tier1',
    'Nearby': 'tier2',
    'Area': 'tier3'
  };

  var finalState = results.reduce(function (state, result) {
    var newResult = shallowCopy(result);

    newResult.queryString = {
      type: result.displayType,
      tier: locationMatchToAnalyticsTier[result.locationMatch] || 'no_tier',
      pos: result.isPremium ? state.premiumCounter : state.standardCounter
    };

    if (location && location.whereId) {
      newResult.queryString.whereid = location.whereId;
    }

    return {
      results: state.results.concat(newResult),
      premiumCounter: state.premiumCounter + (result.isPremium ? 1 : 0),
      standardCounter: state.standardCounter + (result.isPremium ? 0 : 1)
    };
  }, initialState);

  return finalState.results;
}

module.exports = function (params) {
  var page = params.page;
  var results = addQueryStringToResults(params.searchParams, params.results, params.location, page);
  var location = params.location;
  var totalCount = params.totalCount;
  var suggestions = params.suggestions;
  var searchParams = params.searchParams;

  var isLoading = results === null;
  var isZeroResults = !isLoading && results.length === 0;
  var summary = isLoading ? null : {
    displayTotalCount: addCommas(totalCount),
    text: (totalCount === 1 ? 'job' : 'jobs') + ' found'
  };
  var tiersExist = !isLoading && !isZeroResults && areJobsTiered(results);
  var jobs = tiersExist || isZeroResults ? null : results;
  var tier1Jobs = tiersExist ? results.filter(isTier1Job) : null;
  var tier2Jobs = tiersExist ? results.filter(isTier2Job) : null;
  var tier3Jobs = tiersExist ? results.filter(isTier3Job) : null;
  var suggestionsExist = suggestions && suggestions.length > 0;
  var header = page === '1' ? getHeader(isZeroResults, tiersExist, tier1Jobs, tier2Jobs, location, suggestionsExist) : null;
  var tiers = tiersExist ? getTiers(results, tier1Jobs, tier2Jobs, tier3Jobs, location) : null;
  var suggestionsResult = suggestionsExist && page === '1' ? suggestions.map(function (suggestion) {
    return {
      label: suggestion.description,
      refineParams: assign(shallowCopy(searchParams), {
        where: suggestion.description
      })
    };
  }) : null;
  var hasHeaderBeforeJobs = header || tiersExist && (tiers[1].header && !tiers[1].header.isDivider || tiers[2].header && !tiers[2].header.isDivider);

  return {
    isLoading: isLoading,
    isZeroResults: isZeroResults,
    summary: summary,
    jobs: jobs,
    header: header,
    tiers: tiers,
    suggestions: suggestionsResult,
    hasHeaderBeforeJobs: hasHeaderBeforeJobs
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-refine-job-search/dist/view-models/search-results/search-results.js
 ** module id = 478
 ** module chunks = 0
 **/